import { useQuery } from "@tanstack/react-query"
import moment from "moment"

import client from "utils/client"

const canFetchExchangeRate = ({ currency, service_date: serviceDate }) =>
  !!currency && !!serviceDate && !moment(serviceDate).isAfter(moment(), "day")

export const useExchangeRate = (params, options = {}) => {
  const { enabled = true, ...rest } = options

  return useQuery({
    queryKey: ["v2", "exchange_rate", "show", params],
    queryFn: async () => {
      const res = await client.get("/v2/exchange_rate.json", { params })
      return res.data
    },
    retry: false,
    cacheTime: 0,
    refetchOnWindowFocus: true,
    ...rest,
    enabled: enabled && canFetchExchangeRate(params)
  })
}
